"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_components_1 = require("@lws/react-components");

exports.MediaComponent = function (_a) {
  var data = _a.data;
  var media = data.asset('media');

  if (media.type() === react_components_1.AssetType.VIDEO) {
    // TODO(benjamin): Handle this case
    return react_1["default"].createElement(react_1["default"].Fragment, null);
  }

  if (media.type() === react_components_1.AssetType.IMAGE) {
    return react_1["default"].createElement(react_components_1.LsgPicture, {
      fluidData: media.fluid(),
      alt: media.title()
    });
  } // NOTE(benjamin): What's the sane default here? N/A image?


  return react_1["default"].createElement(react_1["default"].Fragment, null);
};